import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../../hooks/useUser";

const AuthRoute = ({ page, category }: { page: JSX.Element, category: number }) => {
    const user = useUser();
    return user?.category === category ? page : <Navigate to="/" />;
}

export default AuthRoute;
